<div class="card flex flex-col flex-1 gap-medpace">
    <div class="flex flex-row justify-between flex-wrap gap-medpace">
        <mds-dropdown
            id="statusFilter"
            [options]="statusOptions"
            [formCtrl]="statusControl"
            [hasSelectAll]="true"
            [filterable]="true"
            [multiple]="true"
            [label]="'Status'"
            [placeholder]="'Filter by Status'"
        />
        <mds-text-field
            [label]="'Search'"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [startIcon]="'search'"
            [formCtrl]="searchControl"
        />
    </div>
    <mds-ag-grid
        [attr.data-cy]="'sitesTable'"
        class="flex-1"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        [columnDefs]="colDefs"
        [tableHeight]="'100%'"
        (gridReady)="gridApi.set($event.api)"
        (rowClicked)="rowClick($event)"
    />
</div>
